module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACzSURBVHgBndONDYIwEAXgd40DMIKJUxhn8YcR3IAR3EDUWYxTkDgCC0i9K4QAgfaOl5BcDu5L21DCyuw+p7P/4QZCTQ4FYUUC0qActGoHY2aQAJlWtIDw7nyuhmJIdXiVKiiFhHp6+tX++bAiEscfFdzNuN7KgAxaEcmGn2zY6LC+1iBhRQ38ddoUwIK072RP7+PFge6IJIb0UApLISNoCdMgktEV+fIAn1kuJbz89jpE8gceDHe1+oAzeQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Icontrial.png
// module id = HsGV
// module chunks = 1